
import AppModal from './AppModal.vue'

export default {
  name: 'ComponentModalSuccess',
  components: {
    AppModal,
  },
}
